import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/crypto-staking-calculator',
  component: () => import('../../routes/CryptoStakingCalculator.svelte'),
  card: {
    id: 'crypto-staking-calculator',
    title: 'Crypto Staking Rewards',
    description: 'Calculate cryptocurrency staking rewards (passive income) from proof-of-stake coins. Supports compound and simple interest, multiple coin presets, and year-by-year breakdown.',
    icon: 'savings',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/crypto-staking-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Crypto Staking Rewards Calculator – Estimate PoS Staking Income',
    description:
      'Free crypto staking rewards calculator. Estimate your passive income from staking Ethereum, Solana, Cardano, Polkadot, Cosmos, and other proof-of-stake coins. Supports compound and simple interest, daily/monthly/yearly compounding, and year-by-year growth breakdown.',
  },
};

export default meta;
